// @flow
import React, { Component } from 'react'
import AjaxDeleteButton from '../controls/AjaxDeleteButton'
import Menu from './Menu'
import { translations, translateFunc } from '../../shared/localize'
import * as operations from '../../redux/ducks/renameCampaignForm/operations'
import { Link, MenuItem, BodyRow, Cell, Tooltip } from '../MainTable'
import OriginalTooltip from '../Tooltip'
import styled, { type StyledComponent } from 'styled-components'
import Checkbox from '../controls/Checkbox'
import _ from 'lodash'

const MenuLink: StyledComponent<Object, any, any> = styled.a`
  text-decoration: none;
`
const NewAudienceLinkWrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline;
`
const NewAudienceLink: any = styled(Link)`
  font-weight: bold;
`
const MenuWraper: StyledComponent<Object, any, any> = styled.div`
  padding-left: 6px;
`
export const Collapser: any = styled(Link)`
  position: relative;
  white-space: nowrap;
  margin: 0 15px 0 0;
`
export const CollapserTriangle: StyledComponent<Object, any, any> = styled.span`
  width: 0;
  height: 0;
  border-top: ${({ isActive }: Object) => (isActive ? 'none' : '5px solid')};
  border-bottom: ${({ isActive }: Object) => (isActive ? '5px solid' : 'none')};
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  position: absolute;
  top: 5px;
  right: -10px;
`
const NameCellContent: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  align-items: center;
`
const Name: StyledComponent<Object, any, any> = styled.div`
  padding-right: 10px;
`

type Props = {|
  locale: string,
  id: number,
  campaignName: string,
  showCode?: boolean,
  codeContent?: string,
  archiveUrl: string,
  audiencesCount: number,
  newAudiencePath: string,
  advertisementsCount: number,
  detailStatisticsPath: string,
  budget: string,
  statistics: Object,
  isCollapsed?: boolean,
  onCollapse?: Function,
  onArchive?: Function,
  onArchivationRollback?: Function,
  isLastInGroup?: boolean,
  isFirstCampaign?: boolean,
  campaignCheckboxChecked: boolean,
  onCampaignCheckboxChange: Function,
  selectedFields: Array<string>,
  totalLimit: string
|}

type State = {|
  showCodePopup: boolean
|}

export default class CampaignTableRow extends Component<Props, State> {
  t: Function

  constructor(props: Props) {
    super(props)

    this.t = translateFunc(translations.campaigns_table, { locale: props.locale })

    this.state = {
      showCodePopup: false
    }
  }

  render() {
    const {
      campaignName,
      showCode,
      codeContent,
      isCollapsed,
      audiencesCount,
      newAudiencePath,
      advertisementsCount,
      budget,
      statistics,
      detailStatisticsPath,
      isLastInGroup,
      isFirstCampaign,
      selectedFields,
      totalLimit
    } = this.props

    return (
      <BodyRow className="t-CampaignRow" topShadow={!isFirstCampaign} bottomShadow={isLastInGroup}>
        <Cell>
          <Checkbox
            className="t-CampaignRowCheckbox"
            onChange={(checked) => {
              this.props.onCampaignCheckboxChange(checked)
            }}
            checked={this.props.campaignCheckboxChecked}
          />
        </Cell>
        <Cell>
          <NameCellContent>
            <Name>
              <div>{campaignName}</div>
              {showCode && (
                <div>
                  <OriginalTooltip
                    isInteractive
                    position="right"
                    isOpen={this.state.showCodePopup}
                    onClose={() => this.setState({ showCodePopup: false })}
                    content={
                      <div className="code-popup">
                        <div className="code-popup__hint">{this.t('counter_code_comment')}</div>
                        <textarea
                          className="code-popup__code"
                          rows={10}
                          cols={100}
                          value={codeContent}
                          onChange={() => {}}
                        />
                      </div>
                    }
                  >
                    <Link onClick={() => this.setState({ showCodePopup: true })}>
                      <span>{this.t('code_to_be_set')}</span>
                    </Link>
                  </OriginalTooltip>
                </div>
              )}
            </Name>
            <Collapser onClick={() => this.collapseClicked()}>
              {this.t('audiences_count', { smart_count: audiencesCount })}
              {audiencesCount > 0 && <CollapserTriangle isActive={!isCollapsed} />}
            </Collapser>
            <Tooltip content={this.t('create_new_audience')}>
              <NewAudienceLinkWrapper>
                <NewAudienceLink className="plus plus_blue" href={newAudiencePath}>
                  +
                </NewAudienceLink>
              </NewAudienceLinkWrapper>
            </Tooltip>
          </NameCellContent>
        </Cell>
        <Cell />
        <Cell className="nowrap">
          <span>{this.t('advertisements_count', { smart_count: advertisementsCount })}</span>
        </Cell>
        {_.map(selectedFields, (field: string) => {
          switch (field) {
            case 'budget':
              return (
                <Cell alignRight className="nowrap" key="campaign_budget">
                  {budget}
                </Cell>
              )
            case 'payment':
            case 'cpc_effective':
            case 'cpm_effective':
            case 'placement_type':
            case 'providers_list':
            case 'platform':
            case 'fb_placements':
            case 'vk_placement':
            case 'included_locations':
            case 'sex':
            case 'age':
            case 'interests':
            case 'demographics':
              return <Cell alignRight className="nowrap" key={`campaign_${field}`} />
            case 'total_limit':
              return (
                <Cell alignRight className="nowrap" key="campaign_total_limit">
                  {totalLimit}
                </Cell>
              )
            case 'spent':
              return (
                <Cell alignRight className="t-StatLink" key={`campaign_${field}`}>
                  <a href={detailStatisticsPath}>{statistics[field]}</a>
                </Cell>
              )
            case 'users':
              return <Cell className="nowrap" key={`campaign_${field}`} />
            default:
              return (
                <Cell alignRight className="nowrap" key={`campaign_${field}`}>
                  {statistics[field]}
                </Cell>
              )
          }
        })}
        <Cell alignRight className="">
          {this.renderMenu()}
        </Cell>
      </BodyRow>
    )
  }

  renderMenu() {
    const {
      id,
      campaignName,
      newAudiencePath,
      detailStatisticsPath,
      archiveUrl,
      onArchive,
      onArchivationRollback
    } = this.props

    return (
      <MenuWraper>
        <Menu className="t-RowMenu t-Menu">
          <MenuLink href={newAudiencePath}>
            <MenuItem>{this.t('create_audience')}</MenuItem>
          </MenuLink>
          <MenuLink href={detailStatisticsPath}>
            <MenuItem>{this.t('statistics')}</MenuItem>
          </MenuLink>
          <MenuItem>
            <AjaxDeleteButton
              url={archiveUrl}
              onStart={() => onArchive && onArchive()}
              onFail={() => onArchivationRollback && onArchivationRollback()}
            >
              {this.t('archivate')}
            </AjaxDeleteButton>
          </MenuItem>
          <MenuLink
            href="#"
            onClick={(e) => {
              operations.openFormFromCampaign(id, campaignName)
              e.preventDefault()
            }}
            className="t-RenameCampaign"
          >
            <MenuItem>{this.t('rename_campaign')}</MenuItem>
          </MenuLink>
        </Menu>
      </MenuWraper>
    )
  }

  collapseClicked() {
    this.props.onCollapse && this.props.onCollapse(!this.props.isCollapsed)
  }
}
